import React, { lazy, memo } from 'react'
import SuspenseWithCatch from '../ui/SuspenseWithCatch'
import SomethingWentWrong from '../ui/SomethingWentWrong'
import type { OwnProps } from './Main'
import { Bundles, loadBundle } from '../../util/moduleLoader'

const MainAsync = lazy(() => loadBundle(Bundles.Main).then((bundle) => ({ default: bundle.Main })))

const Main = (props: OwnProps) => {
  return (
    <SuspenseWithCatch fallback={<SomethingWentWrong />}>
      <MainAsync {...props} />
    </SuspenseWithCatch>
  )
}

export default memo(Main)
